import React from 'react'
import { useCart } from '../context/CartContext'

const Cart = ({ isOpen, onClose }) => {
 const { cartItems, removeFromCart, updateQuantity, getCartTotal, clearCart } = useCart()

 if (!isOpen) return null

 return (
 <div style={{
 position: 'fixed',
 top:0,
 right:0,
 width: '100%',
 height: '100%',
 background: 'rgba(0,0,0,0.5)',
 display: 'flex',
 justifyContent: 'flex-end',
 zIndex:10000
 }}>
 <div style={{
 width: '400px',
 height: '100%',
 background: 'var(--white)',
 boxShadow: '-4px 0px 20px rgba(0,0,0,0.1)',
 display: 'flex',
 flexDirection: 'column'
 }}>
 <div style={{
 padding: '24px',
 borderBottom: '1px solid #e5e7eb',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'space-between'
 }}>
 <h3 style={{
 fontSize: '1.25rem',
 fontWeight: '600',
 color: 'var(--text-dark)'
 }}>
购物车 ({cartItems.length})
 </h3>
 <button onClick={onClose} style={{
 background: 'none',
 border: 'none',
 fontSize: '24px',
 cursor: 'pointer',
 color: 'var(--text-light)'
 }}>
 × </button>
 </div>

 <div style={{
 flex:1,
 overflow: 'auto',
 padding: '24px'
 }}>
 {cartItems.length ===0 ? (
 <div style={{
 textAlign: 'center',
 color: 'var(--text-light)',
 padding: '60px 20px'
 }}>
 <div style={{
 fontSize: '48px',
 marginBottom: '16px'
 }}>
 🛒 </div>
 <p>购物车为空</p>
 </div>
 ) : (
 <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
 {cartItems.map(item => (
 <div key={item.id} style={{
 display: 'flex',
 gap: '12px',
 padding: '16px',
 background: 'var(--background)',
 borderRadius: '12px'
 }}>
 <div style={{
 width: '60px',
 height: '60px',
 background: 'linear-gradient(135deg, rgba(255,107,139,0.1), rgba(139,92,246,0.1))',
 borderRadius: '8px',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 fontSize: '20px'
 }}>
 🧁 </div>
 <div style={{ flex:1 }}>
 <h4 style={{
 fontSize: '1rem',
 fontWeight: '600',
 marginBottom: '4px',
 color: 'var(--text-dark)'
 }}>
 {item.name}
 </h4>
 <p style={{
 color: 'var(--primary)',
 fontWeight: '600',
 fontSize: '1rem'
 }}>
 ¥{item.price}
 </p>
 </div>
 <div style={{
 display: 'flex',
 alignItems: 'center',
 gap: '8px'
 }}>
 <button onClick={() => updateQuantity(item.id, item.quantity -1)}
 style={{
 width: '28px',
 height: '28px',
 background: 'var(--white)',
 border: '1px solid #e5e7eb',
 borderRadius: '4px',
 cursor: 'pointer'
 }}>
 -
 </button>
 <span style={{
 minWidth: '30px',
 textAlign: 'center',
 fontWeight: '600'
 }}>
 {item.quantity}
 </span>
 <button onClick={() => updateQuantity(item.id, item.quantity +1)}
 style={{
 width: '28px',
 height: '28px',
 background: 'var(--white)',
 border: '1px solid #e5e7eb',
 borderRadius: '4px',
 cursor: 'pointer'
 }}>
 +
 </button>
 </div>
 <button onClick={() => removeFromCart(item.id)}
 style={{
 background: 'none',
 border: 'none',
 color: 'var(--text-light)',
 cursor: 'pointer',
 padding: '4px'
 }}>
 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
 <path d="M18 6l-6 6m0 0l-6-6"></path>
 </svg>
 </button>
 </div>
 ))}
 </div>
 )}
 </div>

 {cartItems.length >0 && (
 <div style={{
 padding: '24px',
 borderTop: '1px solid #e5e7eb',
 background: 'var(--white)'
 }}>
 <div style={{
 display: 'flex',
 justifyContent: 'space-between',
 alignItems: 'center',
 marginBottom: '20px',
 fontSize: '1.125rem',
 fontWeight: '600'
 }}>
 <span>总计:</span>
 <span style={{ color: 'var(--primary)' }}>¥{getCartTotal()}</span>
 </div>
 <div style={{ display: 'flex', gap: '12px' }}>
 <button onClick={clearCart}
 className="btn btn-secondary"
 style={{ flex:1, padding: '12px' }}
 >
清空购物车 </button>
 <button className="btn btn-primary" style={{ flex:2, padding: '12px' }}>
立即下单 </button>
 </div>
 </div>
 )}
 </div>
 </div>
 )
}

export default Cart